'use strict';

const { h } = require('phy');
const { hydrate } = require('@grpn/hydration');

const OfferRedemptionText = require('../../shared/views/offer/offer-redemption-text');
const redemptionHandler = require('../../support/redemption-handler');
const { publish } = require('../../support/event-observer');

function CouponButton({ coupon, routes, className = '', referralSource = '' }) {
  const clickRedemptionHandler = () =>
    redemptionHandler({
      routes,
      offerId: coupon.offerId,
      referralSource,
    }).then(data => publish('@redemption', data));

  const keyUpRedemptionHandler = ev => {
    if (ev.keyCode === 13) {
      clickRedemptionHandler();
    }
  };

  return h(
    `a.${className}`,
    {
      tabindex: 0,
      onClick: clickRedemptionHandler,
      onKeyUp: keyUpRedemptionHandler,
      'data-bhc': `type:${coupon.offerType}`,
    },
    [
      OfferRedemptionText({
        type: coupon.offerType,
      }),
    ]
  );
}

module.exports = hydrate('CouponButton', CouponButton);
